"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/skeleton/style/css");
var skeleton_1 = __importDefault(require("antd/lib/skeleton"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
require("antd/lib/modal/style/css");
var modal_1 = __importDefault(require("antd/lib/modal"));
require("antd/lib/form/style/css");
var form_1 = __importDefault(require("antd/lib/form"));
require("antd/lib/input/style/css");
var input_1 = __importDefault(require("antd/lib/input"));
require("antd/lib/typography/style/css");
var typography_1 = __importDefault(require("antd/lib/typography"));
require("antd/lib/message/style/css");
var message_1 = __importDefault(require("antd/lib/message"));
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var auth0_react_1 = require("@auth0/auth0-react");
var SettingsForm_1 = __importDefault(require("./SettingsForm"));
var hooks_1 = require("../../modules/server/hooks");
var actions_1 = require("../../modules/settings/actions");
var utils_1 = require("../../utils");
var c = __importStar(require("../../config"));
var hooks_2 = require("../../hooks");
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var SettingsPage = /*#__PURE__*/ react_1.default.memo(function () {
    var dispatch = (0, hooks_2.useAppDispatch)();
    var settingsInitialFetch = (0, hooks_2.useAppSelector)(function (state) {
        return state.settings.initialFetchDone;
    });
    var fetchingSettings = (0, hooks_2.useAppSelector)(function (state) {
        return state.settings.isFetching;
    });
    var updatingSettings = (0, hooks_2.useAppSelector)(function (state) {
        return state.settings.isUpdating;
    });
    var settings = (0, hooks_2.useAppSelector)(function (state) {
        return state.settings.data;
    });
    var _useCachedServerConfi = (0, hooks_1.useCachedServerConfig)(), serverConfig = _useCachedServerConfi.config;
    var _useAuth = (0, auth0_react_1.useAuth0)(), getAccessTokenSilently = _useAuth.getAccessTokenSilently;
    var _useState = (0, react_1.useState)(false), _useState2 = _slicedToArray(_useState, 2), configShown = _useState2[0], setConfigShown = _useState2[1];
    var onFinish = (0, react_1.useCallback)(/*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(v) {
            var accessToken, result;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            console.log("saving settings", v);
                            _context.n = 1;
                            return getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE);
                        case 1:
                            accessToken = _context.v;
                            _context.n = 2;
                            return dispatch((0, actions_1.updateSettings)(v, accessToken));
                        case 2:
                            result = _context.v;
                            if (!result.error) {
                                message_1.default.success("Saved changes to settings");
                            }
                        case 3:
                            return _context.a(2);
                    }
            }, _callee);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }(), [getAccessTokenSilently, dispatch]);
    var showConfig = (0, react_1.useCallback)(function () {
        return setConfigShown(true);
    }, []);
    var hideConfig = (0, react_1.useCallback)(function () {
        return setConfigShown(false);
    }, []);
    // noinspection JSValidateTypes
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
        children: [(0, jsx_runtime_1.jsxs)(modal_1.default, {
                open: configShown,
                onCancel: hideConfig,
                footer: null,
                children: [(0, jsx_runtime_1.jsx)(typography_1.default.Title, {
                        level: 3,
                        children: "Front End"
                    }), (0, jsx_runtime_1.jsx)(form_1.default, {
                        children: Object.entries(c).map(function (_ref2) {
                            var _ref3 = _slicedToArray(_ref2, 2), ck = _ref3[0], cv = _ref3[1];
                            return (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                                label: ck,
                                children: (0, jsx_runtime_1.jsx)(input_1.default, {
                                    value: cv
                                })
                            }, ck);
                        })
                    }), (0, jsx_runtime_1.jsx)(typography_1.default.Title, {
                        level: 3,
                        children: "Back End"
                    }), (0, jsx_runtime_1.jsx)(form_1.default, {
                        children: Object.entries(serverConfig).map(function (_ref4) {
                            var _ref5 = _slicedToArray(_ref4, 2), ck = _ref5[0], cv = _ref5[1];
                            return (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                                label: ck,
                                children: (0, jsx_runtime_1.jsx)(input_1.default, {
                                    value: cv.toString()
                                })
                            }, ck);
                        })
                    })]
            }), (0, jsx_runtime_1.jsx)(page_header_1.default, {
                title: "Settings",
                ghost: false,
                extra: [(0, jsx_runtime_1.jsx)(button_1.default, {
                        loading: !settingsInitialFetch && fetchingSettings,
                        onClick: showConfig,
                        children: "View Instance Configuration"
                    }, "config")],
                children: settings ? (0, jsx_runtime_1.jsx)(SettingsForm_1.default, {
                    initialValues: settings,
                    onFinish: onFinish,
                    loading: updatingSettings
                }) : (0, jsx_runtime_1.jsx)(skeleton_1.default, {
                    title: false
                })
            })]
    });
});
exports.default = SettingsPage;
